import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";

export class OpenPercentagesPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenPercentagesPopup;
    canExecute = ko.computed(() => {
        return this.app.state.estimate() != undefined;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.percentages, false);
    }

    name = "Edit Percentages";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openPercentagesPopupCommand.ts